export const TeamFormModal = () => import("@teams/components/modals/TeamFormModal.vue");
export const RosterModal = () => import("@teams/components/modals/RosterModal.vue");

export default { TeamFormModal, RosterModal };
